/*
 * Calendar Event - Agenda View directive
 * Provides the template for the individual events in the calendar,
 * while the calendar is in agenda view. 
 *
 * Angular module: trackerbase-app.views.tracking-calendar-view.calendar-agenda-event
 * Directive: tbCalendarAgendaEvent (or tb-calendar-agenda-event)
 */
import angular from "angular";

import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import CalendarAgendaEventController from "./CalendarAgendaEventController";

class CalendarAgendaEventDirectiveDefinition {
    constructor() {
        this.template = CalendarAgendaEventController.template;
        this.restrict = "E";
        this.scope = {
            eventData: "=tbEventData",
            editorNavigateFn: "&tbEditorNavigateFn",
            eventSelected: "&tbEventSelected",
            eventTextClass: "@tbEventTextClass"
        };

        this.controller = CalendarAgendaEventController;
        this.controllerAs = CalendarAgendaEventController.controllerAs;
        this.bindToController = true;
    }

    link($scope, $element, $attrs) {
        angular.noop($attrs);
        angular.noop($scope);

        if ($element != null) {
            let eventWrapper = $element.closest(".tb-calendar-event-expand.tb-event-template");
            eventWrapper.addClass("tb-no-expand");
        }
    }
}

function CalendarAgendaEventDirectiveDefinitionFactory() {
    return new CalendarAgendaEventDirectiveDefinition();
}

CalendarAgendaEventDirectiveDefinitionFactory.$inject = [];

const calendarAgendaEventDirective = {
    name: "tbCalendarAgendaEvent",
    definition: CalendarAgendaEventDirectiveDefinitionFactory,
    dependencies: DependencyListBuilder([
        CalendarAgendaEventController.dependencies
    ])
};

export default calendarAgendaEventDirective;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarAgendaEvent.js
// module id = 2zsJ
// module chunks = 1